var map = {
	"./a023-short1.jpg": 263,
	"./a023-short2.jpg": 264,
	"./a023-short3.jpg": 265,
	"./a023-short4.jpg": 266,
	"./a023-short5.jpg": 267,
	"./a023-short6.jpg": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2780;